import 'core-js/stable/url-search-params';
import Cookies from 'js-cookie';
import { activateNotifications } from './../../../../lib/push';

class Chat {
	constructor(button) {
		this.button = button;
		this.offer = this.button.closest('article.offer');
		this.button.addEventListener('click', () => {
			this.offer.classList.contains('chat_opened') ? this.close() : this.open();
		});

		const open_chat =
			new URLSearchParams(window.location.search).get('open_chat');

		if (open_chat) this.open();
	}

	open() {
		const offer_wrapper = this.offer.closest('section.offer, li');
		activateNotifications({
			subscriptionAuth: this.offer.dataset.chatSubscriptionAuth,
			chatKey: this.offer.dataset.chatKey,
			publicVapidKey: this.offer.dataset.chatPublicVapidKey,
			workerPath: "/worker",
			workerScope: '/'
		});

		const chat_notifications_form_data = new FormData();

		chat_notifications_form_data
			.append('transportation_offer_id', offer_wrapper.dataset.id);
		chat_notifications_form_data
			.append('role', offer_wrapper.dataset.role);
		chat_notifications_form_data
			.append('session_key', Cookies.get('session_key'));

		fetch('/site/cabinet/chats/clear_chat_notifications', {
			method: 'POST',
			body: chat_notifications_form_data
		}).then(response => {
			if (response.status != 200) {
				console.error(response.body);
				throw new Error(response.status);
			}
		});

		this.offer.classList.toggle('chat_opened');

		this
			.offer
			.querySelector('.chat iframe')
			.contentWindow
			.postMessage({ 'func': 'setChatFocus' }, '*');

		this.changeTextElement();
	}

	close() {
		this.offer.classList.toggle('chat_opened');
		this.changeTextElement();
	}

	changeTextElement() {
		const
			text_element = this.button.querySelector('[data-toggle-text]'),
			old_text = text_element.innerText;
		text_element.innerText = text_element.dataset.toggleText;
		text_element.dataset.toggleText = old_text;
	}
}

export { Chat };
